import { useMutation, useQueryClient } from '@tanstack/react-query'
import { postBlockAction } from 'api/admin/companyWorker/blockAction'
import { companyWorkerKeys } from './keys'

export const useBlockWorker = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: postBlockAction,
    onSuccess: async () =>
      queryClient.invalidateQueries({ queryKey: companyWorkerKeys.all }),
  })
}
